import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useShop } from "./ShopContext";

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const { activeShopId } = useShop();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!activeShopId) return;
    setLoading(true);
    try {
      const r = await api.get(`/sessions/current?shop_id=${activeShopId}`);
      setSession(r.data || null);
    } catch {
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, [activeShopId]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SessionContext.Provider value={{ session, loading, refresh, setSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
